import { render, staticRenderFns } from "./ResidentInfo.vue?vue&type=template&id=00d3de2c&scoped=true"
import script from "./ResidentInfo.vue?vue&type=script&lang=js"
export * from "./ResidentInfo.vue?vue&type=script&lang=js"
import style0 from "./ResidentInfo.vue?vue&type=style&index=0&id=00d3de2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3de2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCardTitle,VListItem,VListItemAction,VListItemTitle})
